import './hto-home.scss';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// actions
import { googleConversionAnalyticsHTO, triggerDtmOnload } from '../../hto-utils';
// components
import PersonalOptician from '../../components/PersonalOptician/PersonalOptician';
import Carousel from '../../../../desktop/components/Carousel/Carousel';
import CheckoutHeader from '../../../../desktop/components/Checkout/CheckoutHeader/CheckoutHeader';
import HTOAddressForm from '../../containers/HTOAddressForm/HTOAddressForm';

function HTOHome({ active, htoConfig, navTo, dataLocale }) {
    const carouselConfig = { infinite: true, speed: 2000, slidesToShow: 1, initialSlide: 0, autoplay: true, fade: true, arrows: false, dots: false };

    const [slides, setSlides] = useState([]);
    let timerSlide = null;
    const setCarouselSlides = () => {
        const slides = htoConfig.backgroundCarousel.map((slide, index) => <div key={index}><img src={slide.img} alt="home_try_on simple_procedure" /></div>);
        setSlides(slides);
    };

    useEffect(() => {
        timerSlide = window.setTimeout(() => {
            setCarouselSlides();
            googleConversionAnalyticsHTO();
        }, 100);
        triggerDtmOnload('book an appointment');
        return () => {
            window.clearTimeout(timerSlide);
        };
    }, []);

    return (
        <div className="hto-home">
            <CheckoutHeader logo={htoConfig.home.logo} className="hto-header" pageTitle={htoConfig.home.pageTitle} supportEmail={htoConfig.home.supportEmail} />
            <div className="clear-both"></div>
            <PersonalOptician about={htoConfig.personalOptician.description} heading={htoConfig.personalOptician.heading} />
            <HTOAddressForm active={active} navTo={navTo} />
            <Carousel carouselConfig={carouselConfig} dataLocale={dataLocale} carouselHtmlData={slides} carouselStyle="hto-carousel" />
        </div>
    );
}

const mapStateToProps = state => ({
    htoConfig: state.hto.htoConfig,
    dataLocale: state.locale
});

export default connect(mapStateToProps)(HTOHome);
